<template>
</template>

<script>
    import moment from 'moment';
    import _ from 'lodash';
    import draggable from 'vuedraggable';

    export default {
        props: ['assignment', 'user'],
        components: {
            draggable,
        },
        data() {
            return {
                hasProblem: false,
                problemComment: '',
                icdSearch: '',
                results: [],
                codes: this.assignment.codes || [],
                // maxId: 0,
                drag: false,
                enoughTime: false,
                loading: false, // currently prevents multiple send to problem clicks
                showReview: false,
                reviewed: false,
                showPoc: false,
                poced: false,
                completing: false,
            }
        },
        computed: {
            lastProblem: function() {
                return this.assignment.problems.slice(-1)[0];
            },
            date: function() {
                return moment.utc(this.assignment.date).format('MMM DD, YYYY');
            }
        },
        mounted() {
            setTimeout(()=>{
                this.enoughTime = true;
            }, 3000);
        },
        unmounted() {
            this.surrender();
        },
        methods: {
            complete() {
                if (this.assignment.review) {
                    if(!this.reviewed) {
                        this.showReview = true;
                        return;
                    }
                }

                if (this.assignment.poc) {
                    if(!this.poced) {
                        this.showReview = false;
                        this.showPoc = true;
                        return;
                    }
                }

                this.completing = true;
                axios.patch('/assignments/'+this.assignment.id+'/complete')
                    .then(({data}) => {
                        this.next();
                    })
                    .catch(() => {
                        this.completing = false;
                        this.$toast.error('An error occurred while completing your assignment.');
                    });
            },
            review() {
                this.reviewed = true;
                this.complete();
            },
            poc() {
                this.poced = true;
                this.complete();
            },
            toggleProblems() {
                this.hasProblem = !this.hasProblem;
            },
            cancelProblem() {
                this.toggleProblems();
            },
            sendToProblems() {
                this.completing = true;
                this.loading = true;
                axios.patch('/assignments/'+this.assignment.id+'/problem', {comment: this.problemComment})
                    .then(({data}) => {
                        this.next();
                    })
                    .catch(() => {
                        this.completing = false;
                        this.$toast.error('An error occurred while sending to problems.');
                    });
            },
            next() {
                location.reload();
            },
            surrender(e) {
                if(this.lastProblem && this.lastProblem.user_id == this.user.id) {
                    let confirmation = confirm('Are you sure you want to return this document? You will not get credit for this assignment if you do.');

                    if(confirmation) {
                        return true;
                    }

                    e.preventDefault();
                }
            },
            search: _.debounce(function() {
                if (this.icdSearch.length <= 2) {
                    this.results = [];
                    return;
                }
                if (this.icdSearch.indexOf('.') != -1) {
                    var url = 'https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search?sf=code,name&terms=';

                    axios.get(url+ this.icdSearch)
                    .then(({data}) => {
                        this.results = [];
                        data[3].forEach(element => {
                            this.results.push({code: element[0], text: element[1]});
                        });
                    });
                } else {
                    var url = 'https://icd.hhcoder.com/api?search=';
                    axios.get(url+ this.icdSearch)
                    .then(({data}) => {
                        this.results = [];
                        data.forEach(element => {
                            var code = element.code;
                            code = code.slice(0,3) + '.'+ code.slice(3);
                            this.results.push({code: code, text: element.description});
                        });
                    });
                }
            }, 250),
            addCode (code) {
                if (this.codes.includes(code) == false) {
                    this.codes.push(code);
                    this.updateCodes('Code Added');
                } else {
                    alert('Code Already Applied');
                }
            },
            moveCode() {
                this.updateCodes('Code Moved');
            },
            deleteCode(code) {
                this.codes.splice(this.codes.indexOf(code), 1);
                this.updateCodes('Code Removed');
            },
            updateCodes(message=null) {
                axios.patch(`/assignments/${this.assignment.id}/update`, {
                    field: 'codes',
                    codes: this.codes
                }).then(({data}) => {
                    message = message || 'Successfully updated the codes';
                    this.$toast.info(message, {timeout: 2000});
                });
            },
            updateComment(updatedAssignment) {
                this.assignment.coder_comment = updatedAssignment.coder_comment;
            }
        }
    }
</script>
